module.exports = __webpack_public_path__ + "rfm-avatar-loyal.svg?448bb8383fdff3c48dceb0ebe0138c0e";